
const index = () => import('./')
const form = () => import('./form')

export default [
  {
    path: '/comprarFichas',
    name: 'comprarFichas.index',
    component: index,
    children: [
      {
        path: 'form/:id?',
        name: 'comprarFichas.form',
        component: form
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/features/admin/comprarFichas/routes.js